import { Tooltip } from "antd";
import { FunctionComponent } from "react";

interface FolderContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  icon?: React.ReactNode;
  tooltip?: string;
  isSmart?: boolean;
  subtitle?: string;
}

const FolderContainer: FunctionComponent<FolderContainerProps> = ({
  label,
  icon,
  tooltip,
  isSmart,
  subtitle,
  ...rest
}) => {
  return (
    <div style={{ minHeight: 130 }} {...rest}>
      <div style={{ position: "relative" }}>
        <img
          src="/assets/images/purple_folder.png"
          width={"100%"}
          height={100}
        />
        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: 100, display: "flex", alignItems: "center", justifyContent: "center" }}>{icon}</div>
      </div>

      {/* <Tooltip title={tooltip}></Tooltip> */}
      <div className={isSmart ? "gradient-text" : ""} style={{ paddingLeft: 25 }}>{label}</div>
      {subtitle && (
        <div style={{ paddingLeft: 25, fontSize: 11, color: "#999", fontStyle: "italic", marginTop: 2 }}>
          {subtitle}
        </div>
      )}
    </div>
  );
};

export default FolderContainer;
